/* eslint-disable jsx-a11y/anchor-is-valid */
import { LogoutOutlined } from "@mui/icons-material"
import { Avatar, Typography } from "@mui/material"
import { green } from "@mui/material/colors"
import React, { useState, useEffect, useRef } from "react"
import { Navigate, useNavigate } from "react-router-dom"

const Header: React.FC = () => {
    const handleLogout = () => {
        localStorage.removeItem("token")
        window.location.href = "/"
    }
     const navigate = useNavigate()
     const handleLogoClick = ()=>{
        navigate("/home")
     }

    return (
        <div>
            <div className="h-3 bg-[#3ea787] w-full flex"></div>
            <div className="w-full justify-between	 flex text-[#455A64] font-rubik  py-2 px-4 items-center">
                <div className="flex">
                    <div onClick={handleLogoClick} style={{ cursor: "pointer"}} >
                        <img src="/assets/Logo.svg" width={40}/>
                    </div>
                    <div className="ml-4 mt-2">
                        <Typography
                            className="text-[#3ea787]"
                            variant="h6"
                            fontWeight="bold"
                        >
                            Welcome to Zypp
                        </Typography>
                        <Typography className="text-left">
                          
                        </Typography>
                    </div>
                </div>
                <div className="flex">
                    <LogoutOutlined onClick={handleLogout} className="cursor-pointer"></LogoutOutlined>
                    {/* <Avatar sx={{ bgcolor: green[900] }}>N</Avatar> */}
                </div>
            </div>
            <hr />
        </div>
    )
}

export default Header
